import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LIVE_LINK } from "../helpers/url_helper";
export const priorityPLApi = createApi({
  reducerPath: "priorityPLApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/priority` }),
  tagTypes: ["priorityPL"],
  refetchOnFocus: true,
  endpoints: (build) => ({
    fetchAllPriorityPL: build.query({
      query: () => ({
        url: "/priority-pl",
      }),
      providesTags: (result) =>
        result?.priorityPL
          ? [
              ...result.priorityPL.map(({ _id }) => ({
                type: "priorityPL",
                id: _id,
              })),
              { type: "priorityPL", id: "LIST" },
            ]
          : [{ type: "priorityPL", id: "LIST" }],
    }),
    addPriorityPL: build.mutation({
      query: (newRow) => ({
        url: "/priority-pl",
        method: "POST",
        body: newRow,
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityPLApi.util.updateQueryData(
            "fetchAllPriorityPL",
            undefined,
            (draft) => {
              draft.priorityPL.push(newRow); // Optimistically add the new row to the list
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic addition on failure
        }
      },
      invalidatesTags: [{ type: "priorityPL", id: "LIST" }],
    }),
    updatePriorityPL: build.mutation({
      query: (updatedRow) => ({
        url: `priority-pl/${updatedRow._id}`,
        method: "PUT",
        body: updatedRow,
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityPLApi.util.updateQueryData(
            "fetchAllPriorityPL",
            undefined,
            (draft) => {
              const item = draft.priorityPL.find(
                (row) => row._id === updatedRow._id,
              );
              if (item) {
                Object.assign(item, updatedRow); // Apply changes optimistically
              }
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => {
        return [
          { type: "priorityPL", id: updatedRow._id },
          { type: "priorityPL", id: "LIST" },
        ];
      },
    }),
    deletePriorityPL: build.mutation({
      query: (id) => ({
        url: `priority-pl/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityPLApi.util.updateQueryData(
            "fetchAllPriorityPL",
            undefined,
            (draft) => {
              const index = draft.priorityPL.findIndex((row) => row._id === id);
              if (index !== -1) {
                draft.priorityPL.splice(index, 1); // Remove item optimistically
              }
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      },
      invalidatesTags: (result, error, id) => [
        { type: "priorityPL", id },
        { type: "priorityPL", id: "LIST" },
      ],
    }),
    getLogsByOrderId: build.query({
      query: (orderId) => ({
        url: `/logbook/${orderId}`,
        method: "GET",
      }),
    }),
  }),
});
